import React, { useState, useEffect, useImperativeHandle, useMemo, useCallback, ReactNode, useRef, forwardRef, useContext } from "react";
import classnames from 'classnames';
import { useUser } from "@/contexts/UserContext";
import { getAllProducts } from "@/services/product.service";


export const useAlerts = (
    onlySubscribed = true,
    // limitToAccesssLevel = false,
    limitToSubscriptionLevel = true,
) => {
    const {subscribedSkus, company, user} = useUser();

    const allProducts = getAllProducts();

    const finalAlerts = useMemo(() => {
        const alerts = allProducts
            .filter(({ type }) => type === 'alert')
            .map(alert => {
                const alertOptions = alert?.metadata?.alertOptions;
                return {
                    ...alert,
                    alertType: alertOptions?.alertType
                }
            }) 

        if (onlySubscribed) {
            if (!company?.accessLevel) {
                throw Error('missing_company_access_level');
                // return alerts.filter(({ sku }) => subscribedSkus.includes(sku));
            }

            return alerts.filter(({ accessLevels, sku, subscriptionLevel }) => {
                if (limitToSubscriptionLevel && onlySubscribed) {
                    return Number.isFinite(subscriptionLevel) && subscribedSkus.includes(sku)
                }

                return subscribedSkus.includes(sku);
            });
        }

        return alerts;
    }, [allProducts, subscribedSkus, onlySubscribed]);


    return finalAlerts;

};

export default useAlerts;

useAlerts.displayName = 'useAlerts';